import components from './components'
import {LinkService} from './service'

import 'src/styles/global.scss';
import {AutoOption} from 'src/link-components/auto-table/link-auto-option';
import HzeroAutoOption from "./hzero/HzeroAutoOption";
import StaticOption from "./static-table/link-static-option";
import {AddressService} from "./address";
import {DialogService} from "./dialog";
import {ColumnProps} from "./table-expansion/mixins";

import {LinkModuleInjectMixin, NavigatorMixin} from "./navigator-main";
import tooltip from './tooltip';
import clickoutside from './click.outside';
import resource from './resource'
import HzeroAxios from './hzero/HzeroAxios'
import {LinkFlowEditorInstaller} from "./vue-flow-editor";
import {installNavigatorMixin} from "./micro.compatible";


/**
 * 在安装组件时，可能需要自定义默认参数的一些对象，组件另外处理
 * @author  韦胜健
 * @date    2019/11/15 11:50
 */
const processData = {
	AutoOption,
	StaticOption,
	AddressService,
	DialogService,
	ColumnProps,
	HzeroAxios,
}

const LinkVue = window.LinkVue = {
	resource,                                   //用来加载资源的服务
	$utils: window.LinkUtils,                   //link-utils
	Vue,                                        //Vue全局对象
	transitionTime: 150,                        //动画时长
	// zIndex: 1500,                               //遮罩基础zIndex
	lv_theme: 'crm-color',                      //默认主题

	prefixUrl: null,                            //组件请求后端基础url前缀，一般是portal或者link
	publicImportUrlprefix: null,                //通用地址数据导入前缀

	log() {
		console.log(...arguments)
	},
	getZIndex() {
		return window.PopupManager.nextZIndex()
	},
	TYPE: {
		info: {icon: 'icon-info-circle-fill', color: 'primary'},
		warn: {icon: 'icon-alert', color: 'warn'},
		success: {icon: 'icon-checked-circle-fill', color: 'success'},
		error: {icon: 'icon-close-circle-fill', color: 'error'},
		help: {icon: 'icon-help-circle-fill', color: 'info'},
		white: {icon: 'icon-info-circle-fill', color: 'white'},
		black: {icon: 'icon-info-circle-fill', color: 'black'},
	},
	getPage(instance) {
		return instance.$lv.$dom.findComponentUpward(instance, 'pl-navigator-main-page')
	},
	nextTick: () => new Promise((rs) => Vue.prototype.$nextTick(() => rs())),
	async pageRegistry(path) {
		if (!this._pageRegistry) {
			return Promise.reject('plain ui need pageRegistry function when installed.')
		} else {
			return await this._pageRegistry(path)
		}
	},
	async init() {
		await this.$property.initSystemProperty()
		Vue.prototype.$userConfig.init()
	},
	/*创建vue组件实例*/
	newInstance(component, el) {
		if (!el) {
			el = document.createElement('div')
			document.body.appendChild(el)
		}
		return (new this.Vue({render: h => h(component), el, ...this.p_rootOption}).$mount()).$children[0]
	},
	changeTheme(theme) {
		if (!!this.lv_theme) this.$dom.removeClass(document.body, `${this.lv_theme}`)
		this.$dom.addClass(document.body, `${theme}`)
		this.lv_theme = theme
	},

	install(Vue, {pageRegistry, rootOption, publicPath, processComponent, prefixUrl, publicImportUrlprefix} = {}) {
		this.p_rootOption = rootOption
		this._pageRegistry = pageRegistry 					// 页面注册函数
		this.publicPath = publicPath 						// 公共路径配置
		this.prefixUrl = prefixUrl || 'link'				// 当前请求api前缀
		this.publicImportUrlprefix = publicImportUrlprefix	// 通用导入地址前缀

		LinkService(this) 									// 初始linkUI可用服务，并挂到当前插件对象this
		Vue.prototype.$lv = this 							// 当前插件对象全局挂到Vue对象，命名为$lv
		Vue.directive('link-tooltip', tooltip) 				// 设置全局指令
		Vue.directive('link-clickoutside', clickoutside) 	// 设置全局指令
		installNavigatorMixin(Vue, LinkModuleInjectMixin)
		installNavigatorMixin(Vue, NavigatorMixin)			// 全局混入导航跳转相关函数

		/* 全局注册linkUI组件 */
		Object.keys(components).forEach((key) => {
			let component = components[key]
			const registryName = `link-${this.$utils.getKebabCase(key)}` 				// 设置组件默认命名
			if (!!processComponent) { 													// 如果有个性化设置函数则使用个性化函数处理组件，比如可以重命名
				const newComponent = processComponent(registryName, component)
				if (!!newComponent) component = newComponent
			}
			Vue.component(registryName, component) 										// 全局注册
		});

		if (!!processComponent) { 														// 如果有个性化设置函数则使用个性化函数处理默认配置对象，比如覆盖默认AutoOptions默认属性
			Object.keys(processData).forEach(key => processComponent(key, processData[key]))
		}

		Vue.use(LinkFlowEditorInstaller)

		/* 设置table相关配置对象到window对象 */
		window.AutoOption = AutoOption;
		window.HzeroAutoOption = HzeroAutoOption(AutoOption);
		window.StaticOption = StaticOption;
		Vue.prototype.$hzeroHttp = HzeroAxios(window.Axios) 							// hzero请求辅助对象
		window.getAutoTableId = () => new Date().getTime()
	}
};

export default LinkVue

if (typeof window !== 'undefined') {
	window.LinkVue = LinkVue
}
